const REVIEW_WIDGET_SELECTOR = '#judgeme_product_reviews, .jdgm-review-widget, .jm-review-widget';
const REVIEW_COUNT_SELECTOR = '[data-number-of-reviews], [data-review-count], [data-reviews-count]';
const REVIEW_SECTION_SELECTOR = '[id$="__179093038701294dc8"]';

function getReviewCount(widget) {
  const candidates = [widget, ...widget.querySelectorAll(REVIEW_COUNT_SELECTOR)];

  for (const candidate of candidates) {
    for (const attribute of ['data-number-of-reviews', 'data-review-count', 'data-reviews-count']) {
      const rawValue = candidate.getAttribute(attribute);
      if (rawValue === null || rawValue.trim() === '') continue;

      const count = Number.parseInt(rawValue, 10);
      if (Number.isFinite(count)) return count;
    }
  }

  const summary = widget.querySelector(
    '.jdgm-rev-wid__summary-text, .jm-review-widget-minimal-header__reviews-count, [class*="review-count"]'
  );
  const summaryText = summary?.textContent?.trim() ?? '';

  if (/\bno reviews?\b/i.test(summaryText) || /^0\s+(?:product\s+)?reviews?\b/i.test(summaryText)) return 0;

  const countMatch = summaryText.match(/(\d[\d,]*)\s+(?:product\s+)?reviews?\b/i);
  if (countMatch) return Number.parseInt(countMatch[1].replaceAll(',', ''), 10);

  if (widget.querySelector('.jdgm-rev, .jm-review-card, [data-review-id]')) return 1;
  if (/\bno reviews?\b/i.test(widget.textContent ?? '')) return 0;

  return null;
}

function getReviewWidget() {
  const widgets = [...document.querySelectorAll(REVIEW_WIDGET_SELECTOR)];
  return widgets.find((widget) => !widget.classList.contains('jdgm-preview-badge')) ?? null;
}

function setReviewSectionVisibility(section, isEmpty) {
  if (section.classList.contains('clay-reviews-pending')) {
    section.classList.remove('clay-reviews-pending');
  }
  if (section.classList.contains('clay-reviews-empty') !== isEmpty) {
    section.classList.toggle('clay-reviews-empty', isEmpty);
  }
}

function updateReviewSection(hideIfMissing = false) {
  const widget = getReviewWidget();
  const section = widget?.closest('.shopify-section') ?? document.querySelector(REVIEW_SECTION_SELECTOR);
  if (!section) return;

  if (!widget) {
    if (hideIfMissing) {
      setReviewSectionVisibility(section, true);
    }
    return;
  }

  const reviewCount = getReviewCount(widget);
  const widgetWasHiddenByJudgeMe =
    widget.hidden ||
    widget.getAttribute('aria-hidden') === 'true' ||
    widget.style.display === 'none' ||
    window.getComputedStyle(widget).display === 'none';

  if (reviewCount === 0 || (reviewCount === null && widgetWasHiddenByJudgeMe)) {
    setReviewSectionVisibility(section, true);
    return;
  }

  if (reviewCount !== null && reviewCount > 0) {
    setReviewSectionVisibility(section, false);
  }
}

function scrollToReviews(event) {
  const badge = event.target instanceof Element ? event.target.closest('.jdgm-preview-badge') : null;
  if (!badge || !badge.closest('[data-testid="product-information-details"]')) return;

  const widget = getReviewWidget();
  if (!widget) return;

  event.preventDefault();
  widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function initializeJudgeMeIntegration() {
  document.querySelector(REVIEW_SECTION_SELECTOR)?.classList.add('clay-reviews-pending');
  updateReviewSection();
  document.addEventListener('click', scrollToReviews);

  const observer = new MutationObserver(() => updateReviewSection());
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: [
      'class',
      'style',
      'hidden',
      'aria-hidden',
      'data-number-of-reviews',
      'data-review-count',
      'data-reviews-count',
    ],
    childList: true,
    subtree: true,
  });

  window.setTimeout(() => updateReviewSection(true), 2000);
  window.setTimeout(() => updateReviewSection(true), 5000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeJudgeMeIntegration, { once: true });
} else {
  initializeJudgeMeIntegration();
}
